// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PayorAccountMedicalBenefitModelResponse {
    static getAttributeTypeMap() {
        return PayorAccountMedicalBenefitModelResponse.attributeTypeMap;
    }
}
PayorAccountMedicalBenefitModelResponse.discriminator = undefined;
PayorAccountMedicalBenefitModelResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PayorAccountMedicalBenefitModel"
    }
];
//# sourceMappingURL=payorAccountMedicalBenefitModelResponse.js.map